<template>
    <div class="agreement">
        <!-- <h2>小盒学习会员服务协议</h2> -->
        <p>欢迎您开通小盒学习会员。</p>
        <p>小盒学习会员由小盒学习的所有者开发，旨在为小盒学习用户（以下更多的称之为「您」）提供付费的增值会员权益。</p>
        <p>请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或限制责任的相应条款。<b>小盒学习将以加粗或斜体加粗等形式提示您注意限制、免责条款。</b> 未成年人应在法定监护人的陪同下阅读本协议。<p>
        <p>您以任何形式获得并使用小盒学习会员资格，都视为您已阅读并同意接受本协议的约束。如果您对本协议的任何条款表示异议，您可以选择不开通本产品。<p>
        <h3>服务内容</h3>
        <p>1.小盒学习会员是小盒学习为用户打造的增值产品，包含多种专有的会员权益。</p>
        <p>2.您使用小盒学习时的设备或软件版本型号，可能影响您正常享受小盒学习会员权益。当因前述情况出现时，我们将建议您更换设备或提醒您及时升级，以免影响您正常享受全部会员权益。</p>
        <p>3.小盒学习会员所包含的会员权益以小盒学习APP内「会员开通页」公布的信息为准。小盒学习的会员分为不同等级，不同会员等级之间的会员权益会存有差异，具体亦以上述页面的说明为准。小盒学习有权根据业务发展情况调整全部或部分会员权益。前述调整将在上述会员服务页面进行公告，您也可以随时向客服了解当下会员权益的具体情况。</p>
        <h3>开通和终止</h3>
        <p>1.您同意本协议并支付会员费用或通过使用兑换码等其他方式，即可获得小盒学习会员资格（以下简称「会员资格」）。</p>
        <p>2.小盒学习会员有效期：自会员资格开通之日起算，具体有效期限可以在会员个人页面查看。会员在会员有效期内续费或通过其他方式续展会员期限，有效期将相应延长。会员在会员资格到期后未以任何方式续展期限，小盒学习有权停止提供相应会员权益。</p>
        <p>3.您在开通小盒学习会员时，应仔细核对帐号信息、会员期限、会员费用等信息。<b>由于小盒学习会员是数字化商品，基于互联网服务的特殊性和国家相关管理规定，如因您的个人原因发生错误购买或无法正常享受会员权益，小盒学习不能退还相应会员费。</b></p>
        <p>4.<b>会员未使用小盒学习会员权益的，不视为放弃相应权利。但会员如果违反小盒学习各项管理规定，或会员帐号有异常情况，小盒学习有权根据管理规定对相应会员帐号采取限制或冻结措施。此种情况下，会员的帐号功能及会员权益将受到限制。</b></p>
        <h3>会员费用及续费</h3>
        <p>1.小盒学习会员费以您购买小盒学习会员时，小盒学习在会员服务页面标示的价格为准。小盒学习将不时推出优惠活动，并在会员服务页面公示活动信息及活动价格。</p>
        <p>2.<b>若您在购买小盒学习会员时开通了自动续费，则小盒学习会员到期将自动续费。如您不想续期，或不希望自动扣费，您有权在自动扣划下一期费用前关闭自动续费功能。相关规则和说明请见《自动续费协议》。</b></p>
        <h3>会员帐号管理</h3>
        <p>1.会员应合理使用会员权益、享受会员服务。小盒学习将通过页面公告或私信等方式向会员发布通知。会员应及时关注相关信息的更新。</p>
        <p>2.<b>因不能归责于小盒学习的原因导致的会员帐号密码泄露或会员权益受损，小盒学习不承担任何责任。会员发现帐号被盗，应及时修改密码或通过管理规定找回帐号。为避免帐号盗用引起的风险，小盒学习亦有权主动限制、冻结异常帐号，暂停或终止为异常帐号提供会员权益。</b></p>
        <p>3.<b>如果会员因违反小盒学习管理规定而被限制帐号权限（包括禁言、帐号锁定等），其会员资格依旧有效，但所享有的相关会员权益将受到一定限制，例如与发布信息相关的会员权益将无法实现。</b></p>
        <p>4.<b>会员不得以不正当手段获取会员资格，不得将会员帐号以出借、出租、出售等任何形式提供给第三方使用，不得以任何形式向第三方分享或售卖其所享有的会员权益，不得滥用会员权益，不得利用会员资格获取不正当利益。如会员存在不当行为，违反管理规定，或以任何形式损害小盒学习或其他小盒学习用户利益的，小盒学习有权暂停或取消该会员的会员资格，且不退还已收取的会员费。此外，违规会员需承担因此引起的一切责任和后果。</b></p>
        <p>5.<b>同一会员帐号最多可以在五个设备（「设备」指包括但不限于计算机及移动电话、平板电脑等的移动终端设备）上使用，且同一时间内同一帐号最多在两个设备上使用。超过上述范围使用的，小盒学习有权暂停或终止提供会员权益并取消该会员的会员资格。此外，违规会员需承担因此引起的一切责任和后果。</b></p>
        <p>6.<b>因可归责于会员自身的原因引发的纠纷均与小盒学习无关，会员应当自行承担相应责任。如果该等纠纷损害小盒学习的合法权益，小盒学习有权取消该会员的会员资格，且不退还已收取的会员费。同时，小盒学习有权以合法手段维护自身权益。</b></p>
        <h3>协议修改</h3>
        <p>1.<b>根据互联网的发展和有关法律、法规及规范性文件的变化，或者因小盒学习业务发展需要，小盒学习有权对本协议的条款作出修改或变更，一旦本协议的内容发生变动，小盒学习将根据实际情况选择以包括但不限于系统提示、公告、站内信等方式提示您。</b></p>
        <p>2.<b>如果您不同意小盒学习对本协议相关条款所做的修改，您有权停止使用小盒学习会员，并由小盒学习退返您已经交纳但未享受的会员期限所对应的费用。如果您继续使用，则视为您接受小盒学习对本协议相关条款所做的修改。</b></p>
        <h3>适用法律及争议解决</h3>
        <p>1.本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国大陆地区法律。如本协议的任何约定因与中华人民共和国大陆地区的法律抵触而无效，则这些条款将按照尽可能接近本协议原条文的目的进行重新解释，本协议其它约定仍应具有完整的效力及效果。</p>
        <p>2.<b>本协议的签署地点为中华人民共和国北京市朝阳区。若您与小盒学习发生争议的，双方应尽量友好协商解决。协商不成，双方均同意将争议提交至本协议签订地有管辖权的法院管辖。</b></p>
        <h3>其他</h3>
        <p>1.如因不可抗力或其他小盒学习无法控制的原因，导致小盒学习不能正常提供会员权益的，小盒学习将及时发布通知并合理处理善后事宜，尽量降低会员的损失。</p>
        <p>2.如果您对本协议内容有任何疑问，请私信联系客服。</p>
    </div>
</template>

<script>
export default {
  props: {
    source: {
      // and；ios
      type: String
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
}
.agreement {
  padding: 0.4rem 0.3rem 0.6rem;
  background-color: #fff;
}
h2 {
  font-family: PingFangSC-Medium;
  font-size: 0.48rem;
  color: #4a4b4c;
  font-weight: normal;
  margin: .2rem 0;
}
h3 {
  font-family: PingFangSC-Medium;
  font-size: 0.36rem;
  color: #4a4b4c;
  font-weight: normal;
  margin: .2rem 0;
}
p {
  font-family: PingFangSC-Regular;
  font-size: 0.28rem;
  color: #5f6162;
  line-height: 0.48rem;
  text-indent: 0.2rem;
  margin: .2rem 0;
}
/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .agreement {
    margin-top: calc(0.88rem + constant(safe-area-inset-top));
    margin-top: calc(0.88rem + env(safe-area-inset-top));
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .agreement {
    margin-top: calc(0.88rem + constant(safe-area-inset-top));
    margin-top: calc(0.88rem + env(safe-area-inset-top));
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .agreement {
    margin-top: calc(0.88rem + constant(safe-area-inset-top));
    margin-top: calc(0.88rem + env(safe-area-inset-top));
  }
}
</style>